module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lightbox"
  }, [_c('div', {
    staticClass: "big-image text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemSelected.src
    }
  })]), _c('div', {
    staticClass: "galleries"
  }, [_c('div', {
    staticClass: "galleries-list"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "galleries-item"
    }, [_c('img', {
      attrs: {
        "src": item.src
      },
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    })])
  }))]), _c('a', {
    staticClass: "close-lightbox",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClose($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44434af2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LightboxGalleries.vue
// module id = 415
// module chunks = 3